module.exports = __webpack_public_path__ + "static/media/deal-finder.d7b34b39.svg";